// Shared emoji map for chat components
export const cdnHost = () => window.appconfig?.cdn_host;
const emojiImg = (cdn, name) => `<img src="https://cdn${cdn}.${cdnHost()}/static/images/emojis/${name}.png" alt="${name}" width="24" height="24" class="editor-emojiImg" />`;

export const emojiMap = {
  // Longer patterns first to prevent partial matches (e.g. ]:( before :()
  "]:(": emojiImg(1, 'mad'),
  "]:)": emojiImg(1, 'devil'),
  "]:D": emojiImg(2, 'fierce'),
  "]:O": emojiImg(2, 'skeptical'),
  "O:)": emojiImg(3, 'angel'),
  ":'(": emojiImg(2, 'cry'),
  ":-)": emojiImg(0, 'smiley'),
  ":)":  emojiImg(0, 'smiley'),
  ":-(": emojiImg(0, 'sad'),
  ":(":  emojiImg(0, 'sad'),
  ";-)": emojiImg(1, 'wink'),
  ";)":  emojiImg(1, 'wink'),
  ":-D": emojiImg(3, 'laugh'),
  ":D":  emojiImg(3, 'laugh'),
  ":-P": emojiImg(1, 'tongue'),
  ":P":  emojiImg(1, 'tongue'),
  ":-O": emojiImg(3, 'shock'),
  ":O":  emojiImg(3, 'shock'),
  ":-]": emojiImg(2, 'happy'),
  "xD":  emojiImg(0, 'lol'),
  "XD":  emojiImg(0, 'lol'),
  "B-)": emojiImg(3, 'cool'),
  "8-)": emojiImg(1, 'nerd'),
  "D:":  emojiImg(2, 'horror'),
  "o_O": emojiImg(1, 'confused'),
  "-_-": emojiImg(0, 'blank'),
  ":|":  emojiImg(0, 'blank'),
  ":/":  emojiImg(3, 'annoyed'),
  "o.o": emojiImg(3, 'zombie'),
  "^_^": emojiImg(2, 'relieved'),
  "UwU": emojiImg(2, 'kitty'),
};
